import { reactive } from 'vue'
import type { IEsgContactForm } from '@/domains/esg/types/form.types'
import useVuelidate from '@vuelidate/core'
import { useText } from '@/components/Inputs/Composables/validators/useText/useText'
import { useEmail } from '@/components/Inputs/Composables/validators/useEmail/useEmail'
import { useFile } from '@/components/Inputs/Composables/validators/useFile/useFile'

const CONTACT_FORM_INITIAL_STATE: IEsgContactForm = {
  firstName: '',
  lastName: '',
  email: '',
  messageTitle: '',
  messageText: '',
  document: null,
}

export default function useEsgContactForm() {
  const { t } = useI18n()
  const form = reactive({ ...CONTACT_FORM_INITIAL_STATE })

  const $v = useVuelidate({
    ...useText('firstName', t, { length: 40, required: false }),
    ...useText('lastName', t, { length: 80, required: false }),
    ...useEmail('email', t),
    ...useText('messageTitle', t, { length: 128, required: true }),
    ...useText('messageText', t, { length: 512, required: true }),
    ...useFile('document', t, {
      required: false,
      maxSize: 20,
      allowedExtensions: ['doc', 'docx', 'pdf', 'jpg', 'jpeg', 'png'],
    }),
  }, form)

  const resetForm = () => {
    Object.assign(form, CONTACT_FORM_INITIAL_STATE)
    $v.value.$reset()
  }

  return {
    $v,
    form,
    resetForm,
  }
}
